import { logger } from 'services/logger'
import { mixtilesAxios } from '../utils/ApiUtils'

const USER_CAPTURED_DATA_PATH = 'v1/user/userCapturedData'

export const getEmailConsentBraze = async (externalId: string) => {
  const response = await mixtilesAxios.get(
    `${USER_CAPTURED_DATA_PATH}/email-consent-braze`,
    {
      params: {
        external_id: externalId,
      },
    }
  )
  logger.info('Email consent response', {
    externalId,
    response: response?.data,
  })
  return response.data.emailConsent
}

export const unsubscribePhoneProfile = async (
  userId: string
): Promise<void> => {
  await mixtilesAxios.post('/v1/user/unsubscribePhoneProfile', { userId })
}

export const setCustomAttribute = async (
  key: string,
  value: string,
  userId: string
): Promise<void> => {
  await mixtilesAxios.post('/v1/user/setCustomAttribute', {
    key,
    value,
    userId,
  })
}
